
import { cloneDeep } from 'lodash';

/**
 * Created by shiyonggao on 2019/2/25.
 */

/**
 * state 中的方法命名规则（小驼峰规则）
 */
const state = {

};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
const actions = {
    updateAntiAddictionConfig({rootState}, data) {
        const URL =  rootState.$config.api[data.is_edit ? 'anti_addiction_edit_config' : 'anti_addiction_create_config'];
        let params = cloneDeep(data.params);
        console.log("result")
        console.log(data)
        console.log(params)

        params.identified_user_rules.forEach((item,i) => {
            item.login_rule.holiday = {};
            item.login_rule.work_day_normal = {};
            item.login_rule.work_day_special = {};

            data.params.identified_user_rules[i].login_rule.holiday.rules.forEach(keys => {
                if(keys.date_type && keys.date_type === 1) {
                    item.login_rule.holiday.daily_max_game_minutes = keys.daily_max_game_time;
                }else if(keys.date_type && keys.date_type === 2) {
                    if(Array.isArray(item.login_rule.holiday.forbidden_game_minutes_periods)) {
                        item.login_rule.holiday.forbidden_game_minutes_periods.push([keys.start_time,keys.end_time])
                    }else {
                        item.login_rule.holiday.forbidden_game_minutes_periods = [[keys.start_time,keys.end_time]];
                    }
                } else if (keys.date_type && keys.date_type === 3) {
                    if (Array.isArray(item.login_rule.holiday.allow_game_minutes_periods)) {
                        item.login_rule.holiday.allow_game_minutes_periods.push([keys.start_time, keys.end_time])
                    } else {
                        item.login_rule.holiday.allow_game_minutes_periods = [[keys.start_time, keys.end_time]];
                    }
                }
            })
            delete item.login_rule.holiday.changeTimeOptions;
            delete item.login_rule.holiday.rules;


             data.params.identified_user_rules[i].login_rule.work_day_normal.rules.forEach(keys => {
                 if(keys.date_type && keys.date_type === 1) {
                    item.login_rule.work_day_normal.daily_max_game_minutes = keys.daily_max_game_time;
                 }else if(keys.date_type && keys.date_type === 2) {
                     if(Array.isArray(item.login_rule.work_day_normal.forbidden_game_minutes_periods)) {
                        item.login_rule.work_day_normal.forbidden_game_minutes_periods.push([keys.start_time,keys.end_time])
                     }else {
                        item.login_rule.work_day_normal.forbidden_game_minutes_periods = [[keys.start_time,keys.end_time]];
                     }
                 } else if (keys.date_type && keys.date_type === 3) {
                     if (Array.isArray(item.login_rule.work_day_normal.allow_game_minutes_periods)) {
                        item.login_rule.work_day_normal.allow_game_minutes_periods.push([keys.start_time, keys.end_time])
                     } else {
                        item.login_rule.work_day_normal.allow_game_minutes_periods = [[keys.start_time, keys.end_time]];
                     }
                 }
             })
             delete item.login_rule.work_day_normal.changeTimeOptions;
             delete item.login_rule.work_day_normal.rules;



              data.params.identified_user_rules[i].login_rule.work_day_special.rules.forEach(keys => {
                  if(keys.date_type && keys.date_type === 1) {
                    item.login_rule.work_day_special.daily_max_game_minutes = keys.daily_max_game_time;
                  }else if(keys.date_type && keys.date_type === 2) {
                      if(Array.isArray(item.login_rule.work_day_special.forbidden_game_minutes_periods)) {
                        item.login_rule.work_day_special.forbidden_game_minutes_periods.push([keys.start_time,keys.end_time])
                      }else {
                        item.login_rule.work_day_special.forbidden_game_minutes_periods = [[keys.start_time,keys.end_time]];
                      }
                  } else if (keys.date_type && keys.date_type === 3) {
                      if (Array.isArray(item.login_rule.work_day_special.allow_game_minutes_periods)) {
                        item.login_rule.work_day_special.allow_game_minutes_periods.push([keys.start_time, keys.end_time])
                      } else {
                        item.login_rule.work_day_special.allow_game_minutes_periods = [[keys.start_time, keys.end_time]];
                      }
                  }
              })
              delete item.login_rule.work_day_special.changeTimeOptions;
              delete item.login_rule.work_day_special.rules;

        })
        console.log(params)

        return rootState.$helper.request.post(URL, {fields: params})
        .then((res) => {
            return res;
        });
    },
    getAntiAddictionConfig({rootState}){
        const URL = rootState.$config.api.anti_addiction_get_config;
        return rootState.$helper.request.get(URL)
        .then((res) => {
            return res.data;
        });
    }
};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
const getters = {

};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
const mutations = {
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./website/store/modules/antiAddiction/configuration.js